import { render, staticRenderFns } from "./OwalFormInput.vue?vue&type=template&id=6e10a989&scoped=true"
import script from "./OwalFormInput.vue?vue&type=script&lang=js"
export * from "./OwalFormInput.vue?vue&type=script&lang=js"
import style0 from "./OwalFormInput.vue?vue&type=style&index=0&id=6e10a989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10a989",
  null
  
)

export default component.exports